import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { toast } from "sonner";

const REASONS = [
  { key: "threat",  label: "Threat or violence" },
  { key: "hate",    label: "Hate or harassment" },
  { key: "privacy", label: "Privacy / personal information" },
  { key: "scam",    label: "Scam or fraud" },
  { key: "sexual",  label: "Sexual / illegal content" },
  { key: "other",   label: "Other" },
];

export default function ReportModal({ open, onOpenChange, messageId }) {
  const [reason, setReason] = useState("");
  const [detail, setDetail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!reason) return;
    setBusy(true);
    try {
      const r = await api.post(`/messages/${messageId}/report`, { reason, detail });
      setDone(true);
      if (r.data.already_reported) {
        toast.info("You already reported this MESSAGE.");
      } else {
        toast.success("Report received. Thank you.");
      }
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not submit report.");
    } finally { setBusy(false); }
  };

  const close = () => {
    setReason(""); setDetail(""); setDone(false);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="oh-modal max-w-md" data-testid="report-modal">
        <DialogTitle className="oh-label">Report MESSAGE</DialogTitle>
        {done ? (
          <div className="mt-6 space-y-4">
            <div className="font-serif-editorial text-2xl">Thank you.</div>
            <p className="text-sm text-[color:var(--oh-ink-2)] leading-relaxed">
              A human will review this MESSAGE. Reports are private — the
              creator will never see your identity.
            </p>
            <button onClick={close} className="btn-primary w-full" data-testid="report-close">
              Close
            </button>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-5">
            <p className="text-sm text-[color:var(--oh-ink-2)] leading-relaxed">
              Tell VOIHU what concerns you. Reporting does not automatically
              remove content — a human reviews every report.
            </p>
            <div className="space-y-2" data-testid="report-reasons">
              {REASONS.map((r) => (
                <label key={r.key} className="flex items-center gap-3 cursor-pointer text-sm">
                  <input type="radio" name="reason" value={r.key}
                         checked={reason === r.key}
                         onChange={(e) => setReason(e.target.value)}
                         data-testid={`report-reason-${r.key}`} />
                  <span>{r.label}</span>
                </label>
              ))}
            </div>
            <textarea value={detail} rows={3}
                      maxLength={500}
                      onChange={(e) => setDetail(e.target.value.slice(0, 500))}
                      placeholder="Any additional context (optional)"
                      className="oh-input resize-none w-full"
                      data-testid="report-detail" />
            <div className="oh-label text-right text-[color:var(--oh-ink-3)]" data-testid="report-detail-count">
              {detail.length}/500
            </div>
            <button type="submit" disabled={!reason || busy}
                    className="btn-red w-full" data-testid="report-submit">
              {busy ? "Sending…" : "Submit report"}
            </button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}
